import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
  required,
} from 'react-admin';

export const PaymentMethodCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" validate={required()} />

      <ImageInput source="logo" label="Logo" accept="image/*" isRequired>
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="tag_text" label="Tag text" />
      <TextInput
        source="instruction_text"
        label="Instruction text"
        defaultValue="এই নাম্বারে শুধুমাত্র সেন্ড মানি করুন"
        fullWidth
      />

      <BooleanInput source="is_crypto" label="Is crypto" defaultValue={false} />
      <NumberInput source="exchange_rate" label="Exchange rate" defaultValue={1.0} />

      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
      <NumberInput source="sort_order" label="Sort order" defaultValue={0} />
    </SimpleForm>
  </Create>
);

// ---------- EDIT ----------
const formatImage = (value) => {
  if (!value) return value;
  if (typeof value === 'string') {
    return { src: value, title: value };
  }
  return value;
};

const parseImage = (value) => {
  if (!value) return null;
  if (value.rawFile) return value;
  return value.src;
};

export const PaymentMethodEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" validate={required()} />

      <ImageInput
        source="logo"
        label="Logo"
        accept="image/*"
        format={formatImage}
        parse={parseImage}
      >
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="tag_text" label="Tag text" />
      <TextInput
        source="instruction_text"
        label="Instruction text"
        fullWidth
      />

      <BooleanInput source="is_crypto" label="Is crypto" />
      <NumberInput source="exchange_rate" label="Exchange rate" />

      <BooleanInput source="is_active" label="Is active" />
      <NumberInput source="sort_order" label="Sort order" />
    </SimpleForm>
  </Edit>
);